function parseToAdminReservation({
    idReservaManual, nombre, 
    campus, direccion,
    tipoEspacio,
    detalles, finalizado,
    horario: {
        fecha, horaInicio, horaFin
    }
}) {
    return {
        id: idReservaManual,
        name: nombre,
        details: detalles,
        schedule: {
            date: fecha,
            timeStart: horaInicio,
            timeEnd: horaFin
        },
        finalized: finalizado,
        campus, address: direccion,
        spaceType: tipoEspacio
    };
}
function parseToPenalizeStudent({
    idAlumnoSancionado, detalles,
    diasSancion, idMotivo
}) {
    return {
        studentPenalizedId: idAlumnoSancionado,
        details: detalles || "",
        penalizeDays: String(diasSancion),
        reasonForPenalizeId: idMotivo
    };
}
function parseToStudentReservation({
    codAlumno, nombreAlumno,
    idDetalleReserva, sancion,
    asistencia
}) {
    return {
        id: codAlumno,
        name: nombreAlumno,
        reservationDetailId: idDetalleReserva,
        penalty: sancion ? parseToPenalizeStudent(sancion) : null,
        attended: asistencia,
        saved: true,
        forTakeAttendance: false,
        forPenalize: false,
        forUpdatePenalty: false
    };
}
function parseToReservation({
    idReserva, actividad,
    campus, direccion,
    tipoEspacio,
    estudiante, horario: {
        fecha,
        horaInicio,
        horaFin
    },
    finalizado
}) {
    return {
        id: idReserva,
        activity: actividad,
        campus, address: direccion,
        spaceType: tipoEspacio,
        students: {
            responsible: parseToStudentReservation(estudiante.responsable),
            others: estudiante.otros
                ? estudiante.otros.map(parseToStudentReservation)
                : null
        },
        schedule: {
            date: fecha,
            timeStart: horaInicio,
            timeEnd: horaFin
        },
        finalized: finalizado
    };
};

function parseToUniversitySpace({
    espacio: {
        idEspacioUniversitario, nombre,
        idCampus, idTipoEspacio,
        idsActividades, aforoMin, aforoMax,
        direccion, referencia, fueraCampus,
        detalles, activo
    },
    esDiaNoHabil,
    reservas, reservasManuales
}) {
    return {
        space: {
            id: idEspacioUniversitario,
            name: nombre,
            campusId: idCampus,
            spaceTypeId: idTipoEspacio,
            availableActivityIds: idsActividades,
            minCapacity: aforoMin,
            maxCapacity: aforoMax,
            address: direccion || "",
            reference: referencia,
            spaceOutOfCampus: fueraCampus,
            details: detalles || "",
            active: activo
        },
        isNonBusinessDay: esDiaNoHabil,
        reservations: reservas.map(parseToReservation),
        adminReservations: reservasManuales.map(parseToAdminReservation)
    };
};

const helpers = {
    parseToUniversitySpace: parseToUniversitySpace
};

export default helpers;